
const storeKey = "pkzbmerscamps";

const setStore = () => {

    localStorage.setItem(
        storeKey, JSON.stringify({
            list: {
                count: 0,
                data: {}
            }
        })
    );
};

const fill = (data) => {

    if(localStorage.getItem(storeKey) == undefined) setStore();

    let store = localStorage.getItem(storeKey);
    store = JSON.parse(store);

    store.list.count = data.count;
    store.list.data = data.data;

    localStorage.setItem(storeKey, JSON.stringify(store)); 
};

const fetch = (key) => {

    if(localStorage.getItem(storeKey) == undefined) setStore();

    let store = localStorage.getItem(storeKey);
    store = JSON.parse(store);

    return store[key];

};



export const storeCampaigns = {
    fill,
    fetch
};